import cn from "classnames"
import React, { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { CSSTransition } from "react-transition-group"

import { useExportMagLang } from "~/components/LanguageProvider/LanguageProvider"
import { RouterLink } from "~/components/RouterLink/RouterLink"

import { Logo } from "../Logo/Logo"
import { About } from "./components/About/About"
import { Portfolio } from "./components/Portfolio/Portfolio"
import styles from "./index.module.css"

const DropdownMenu = ({ type, closeMenu, menuIsOpen, menu }) => {
  const [isEntered, setEntered] = useState(false)
  const portfolioSubmenu = menu.featurePages || []

  const portfolioItems = portfolioSubmenu.reduce(
    (acc, next, i) => {
      acc[Math.floor(i / Math.ceil(portfolioSubmenu.length / 2))].push(next)
      return acc
    },
    [[], []],
  )

  return (
    <CSSTransition
      classNames={{
        enter: styles.Enter,
        enterActive: styles.EnterActive,
        exit: styles.Exit,
        exitActive: styles.ExitActive,
      }}
      in={menuIsOpen}
      timeout={{ enter: 660, exit: 330 }}
      unmountOnExit
      onEntering={() => setEntered(true)}
      onExit={() => setEntered(false)}
    >
      <div className={styles.Menu} onMouseLeave={closeMenu}>
        <div className="bb-container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              {type === "about" && <About isOpen={isEntered} />}
              {type === "portfolio" && <Portfolio isOpen={isEntered} menuItems={portfolioItems} />}
            </div>
          </div>
        </div>
      </div>
    </CSSTransition>
  )
}

export const DesktopMenu = ({ menuItems, menu, onMenuToogle, style }) => {
  const [menuIsOpen, openDropdown] = useState(false)
  const [menuName, showMenu] = useState(null)
  const menuEl = useRef(null)

  const openMenu = (name) => {
    onMenuToogle(true)
    openDropdown(true)
    showMenu(name)
  }

  const closeMenu = () => {
    onMenuToogle(false)
    openDropdown(false)
  }

  const handleOutsideClick = (e) => {
    if (menuEl && menuEl.current && !menuEl.current.contains(e.target)) {
      document.removeEventListener("mousedown", handleOutsideClick)
      closeMenu()
    }
  }

  const onTouchHandler = (name) => {
    if (menuIsOpen && name === menuName) {
      closeMenu()
    } else {
      document.addEventListener("mousedown", handleOutsideClick)
      openMenu(name)
    }
  }

  const { i18n } = useTranslation()
  const { exportMagLang } = useExportMagLang()
  const currLang = exportMagLang ? exportMagLang : i18n.language

  return (
    <div ref={menuEl} className={styles.Wrapper} style={style}>
      <DropdownMenu
        closeMenu={closeMenu}
        menu={menu}
        menuIsOpen={menuIsOpen}
        menuItems={menuItems}
        type={menuName}
      />

      <div className={styles.Container}>
        <div className={styles.Grid}>
          <Logo />
          <div className={styles.Links}>
            {menuItems.map(({ title, href, submenu, name, isEn }, i) => {
              if (currLang !== "ru" && !isEn) {
                return null
              }
              if (submenu) {
                return (
                  <div
                    key={i}
                    className={cn(styles.ItemDropdown, {
                      [styles.ItemDropdownActive]: menuIsOpen && menuName === name,
                    })}
                    dangerouslySetInnerHTML={{ __html: title.ru ? title[currLang] : title }}
                    onMouseEnter={() => openMenu(name)}
                    onTouchStart={() => onTouchHandler(name)}
                  />
                )
              }

              return (
                <RouterLink
                  key={i}
                  className={styles.Link}
                  href={href.ru ? href[currLang] : href}
                  onMouseEnter={closeMenu}
                >
                  {title.ru ? title[currLang] : title}
                </RouterLink>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
